
import { addSocketMessageListener } from "@/api/socketAPI";
import SocketMessageType from "@/constants/SocketMessageType";
import { store } from "@/store/store";
import { meetingAPI } from "@/api";

const processCalendarUpdate = () => {
	store.dispatch( "schedule/updateInBackground" );
};

const updateScheduleMeetingData = async ( { body, } ) => {
	const { meetingId, meetingSeriesId, outcomeVersion, /* personId, */ } = body;
	if ( outcomeVersion === "v2" ) {
		return;
	}

	if ( !meetingId ) {
		console.warn( "schedule API orchestrator: a meetingId was expected but was not detected" );
		return;
	}
	const options = { version: 2, };
	const userProfile = store.getters[ "userProfile/userProfile" ];
	const timezone = store.getters[ "auth/timezone" ];
	try {
		if ( meetingSeriesId ) {
			store.dispatch( "schedule/updateInBackground" );
		}
		// NOTE: we need to go ahead and refresh the SPECIFIC meeting, because `updateInBackground` only
		// refreshes the currently selected week offset, which may or may NOT be the offset in which the current
		// week is located.
		const meeting = await meetingAPI.getMeeting( { meetingId, }, options );
		// TODO: convert this to an action
		store.commit( "schedule/meetingUpdated", { meeting, userProfile, timezone, } );
	} catch ( e ) {
		if ( e.message !== "Meeting not found" ) {
			console.error( "error updating schedule store", body, e );
		}
	}
};

export const initWebSocketListeners = () => {
	addSocketMessageListener( SocketMessageType.CALENDAR_UPDATED, processCalendarUpdate );

	// updateScheduleMeetingData
	[
		SocketMessageType.MEETING_UPDATED,
		SocketMessageType.OUTCOME_CREATED,
		SocketMessageType.OUTCOME_DELETED,
		SocketMessageType.OUTCOME_UPDATED,
		SocketMessageType.TOPIC_CREATED,
		SocketMessageType.TOPIC_DEFERRED,
		SocketMessageType.TOPIC_DELETED,
		SocketMessageType.TOPIC_UNDEFERRED,
		SocketMessageType.TOPIC_UPDATED,
		SocketMessageType.TOPIC_PINNED,
		SocketMessageType.TOPIC_UNPINNED,
		SocketMessageType.TOPICS_SORTED,
	].forEach( messageType => addSocketMessageListener( messageType, updateScheduleMeetingData ) );
};



// WEBPACK FOOTER //
// ./src/store/modules/schedule/scheduleApiOrchestrator.js